<template>
<div class="columns" style="margin-bottom:0px;">
    <div class="column is-6">
        <div class="field">
            <input v-model="name" @keyup.enter="createAccount" name="custom-schedule" type="text" :class="{ 'is-danger': hasError('name') }" class="input custom-input-size is-medium" placeholder="Account name" autocomplete="off" :disabled="creatingAccount"/>
            <span v-if="!hasError('name')" class="help">An intuitive name to easily recognize the account later.</span>
            <span v-if="hasError('name')" class="help is-danger">{{ getError('name') }}</span>
        </div>
    </div>
    <div class="column is-6">
        <div class="field">
            <input v-model="token" @keyup.enter="createAccount" name="custom-schedule" type="text" :class="{ 'is-danger': hasError('token') }" class="input custom-input-size is-medium" placeholder="API Key" autocomplete="off" :disabled="creatingAccount"/>
            <span v-if="!hasError('token')" class="help">The API Key of your Hetzner project.</span>
            <span v-if="hasError('token')" class="help is-danger">{{ getError('token') }}</span>
        </div>
    </div>
</div>
</template>

<script>
import Api from '@/api';
import FormErrorsMixin from '@/mixins/FormErrors';
import swal from 'sweetalert';

export default {
    mixins: [FormErrorsMixin],

    data() {
        return {
            name: '',
            token: '',
            allowedInputs: ['name', 'token'],
            error: '',
            creatingAccount: false,
        }
    },

    mounted() {
        this.listenEvents();
    },

    methods: {
        createAccount() {
            if (this.creatingAccount) {
                return;
            }

            this.resetErrors();
            this.creatingAccount = true;

            Api().post('accounts', this.newAccountData)
                .then(response => {
                    Event.$emit('refreshAccounts', () => {
                        Event.$emit('closeAddAccount');
                        swal('Success!', 'The Hetzner account was connected.', 'success');
                    });
                })
                .catch(error => {
                    if (!this.storeErrors(error.response.data.errors)) {
                        if (typeof error.response.data.message == 'string') {
                            this.error = error.response.data.message;
                        } else {
                            this.error = 'Something wrong happened. Refresh the page and try again.';
                        }
                    }
                })
                .finally(() => {
                    this.creatingAccount = false;
                });
        },

        listenEvents() {
            let vm = this;

            Event.$on('createProviderAccount', (providerSlug) => {
                if (providerSlug == 'hetzner') {
                    vm.createAccount();
                }
            });

            Event.$on('addAccountClosed', () => {
                this.resetErrors();
                this.name = '';
                this.token = '';
                this.error = '';
            });
        },
    },

    computed: {
        newAccountData() {
            return {
                provider_slug: 'hetzner',
                name: this.name,
                token: this.token,
            }
        },
    },

    watch: {
        creatingAccount(creatingAccount) {
            Event.$emit('creatingAccountLoaderUpdated', creatingAccount);
        },
    },
}
</script>
